import React, { Component } from 'react';
import { InputSelect } from '../../../commonModules/interface/form-input-inline.jsx';
import Spin from '../../../commonModules/interface/Spin';
import { BreadCrumb } from './containers/Layout';
import SingleShop from './shops/SingleShop.jsx';
import FormReappro from './reapproIntern/FormReappro.jsx';
// import ListReappro from './reapproIntern/ListReappro.jsx';
// import SingleReappro from './reapproIntern/SingleReappro';
// import { isEmpty } from 'lodash';
import { Button, Card, Grid, Box } from '@material-ui/core';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import DeleteDialog from '../../../commonModules/interface/DeleteDialog.jsx';
import ShopFilter, { filterShop, filterShopReappro } from './Filter/ShopFilter.jsx';
import DateFilter, { filterDate } from './Filter/DateFilter.jsx';
import { firstDayOfYear, sixMonthsAgo } from '../../../commonModules/utils/statsFunctions.jsx';
import AccordionFilter from './Filter/AccordionFilter.jsx';
import { toast } from 'react-toastify';
import ListTransferReappro from './transfers/reappro/ListTransferReappro.jsx';
import SingleTransferReappro from './transfers/reappro/SingleTransferReappro.jsx';
import { isEmpty } from 'lodash';

class ReapproIntern extends Component{
    state = {
        // Dialog
        showSale:false,
        showNew: this.props.new,

        singleShop:{},
        singleSale:{
            sale:{},
            shop:{},
            shopDest:{},
        },

        breadcrumb: "",
        
        deletePopUp: false,
        toDelete:{
            id:""
        },
        mdpAdmin:"",
        errors:{
            mdpAdmin:"",
        },

        filteredList: [],
        pageOfItems: [],
        currentPage: 0,
        rowsPerPage: 20,
        reload : false,

        search:"",

        selctShopSRC:{
            value:"",
            label:"Tous les Magasins",
        },
        selectShopDEST:{
            value:"",
            label:"Tous les Magasins",
        },
        received: "ALL",
        start_date: sixMonthsAgo,
        // start_date: firstDayOfYear,
        end_date: new Date(),
    }
    
    componentDidMount = () => {
        console.log("MOUNTING Reappro ");
        // this.filterList()
    }
    onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        this.setState({ pageOfItems, currentPage, rowsPerPage });
    }

    shopFilter = (selected) => {
        const { REAPPRO, SHOPS } = this.props
        
        let filteredShop = Object.values(REAPPRO).filter( rea => {
                return (rea.shop_id === selected)
            }
        )
        console.log({filteredShop});
        return filteredShop
    }
    

    // filterList = (selectedShop = this.state.selectSearch, received = this.state.received) => {
    //     console.log({selectedShop, received});
    //     let filteredList = selectedShop ? this.shopFilter(selectedShop) : Object.values(this.props.REAPPRO)
    //     if (typeof received == "boolean"){
    //         filteredList = filteredList.filter(item => this.props.PURCHASES_REAPPRO[item.reappro_purchase_id] && this.props.PURCHASES_REAPPRO[item.reappro_purchase_id].received == received)
    //     }
    //     this.setState({
    //         filteredList,
    //         reload:!this.state.reload
    //     })
    // }

    getFilteredList = () => {
        const { REAPPRO } = this.props
        const {selectShopSRC, selectShopDEST, received } = this.state;
        
        // let list = Object.values(PURCHASES)
        let list = filterDate(REAPPRO, this.state.start_date, this.state.end_date, "creation_date")
        list = filterShopReappro(list, selectShopSRC, selectShopDEST)
        // status
        if (typeof received == "boolean"){
            if (received){
                //si recu
                list = list.filter(item => item.received == received)
            }else{
                //si pas recu (le champ peut ne pass exister)
                list = list.filter(item => (item.received == received ||typeof item.received === "undefined"  ))
            }
        }
        
        return list
    }

    changeStatus = async (transfer) => {
        console.log('[INFO] change status transfers.jsx');
        await this.props.receiveReappro(transfer)
        
        if(this.props.STATE.sales.error){
            console.log("ERROR", this.props.STATE.sales.error);
            toast.error( "Un Problème est survenu")
        } else{
            console.log("fetched");
            // this.filterList(undefined, undefined)
            toast.info("Commande reçue")
        }
    }
    // LISTS & TABLES
        
        
        // createShopList = () => {
        //     const list = [{value:"", label:"Tous les Magasins"}]
        //     const { SHOPS} = this.props
        //     if( SHOPS ){
        //         Object.keys(SHOPS).map((ID)=>{ 
        //             const shop = SHOPS[ID]                    
        //             list.push (       
        //                 {value:ID, label:shop.name} 
        //             )
        //         })
        //     } 
        //     return list
        // }

        
                   
        handleChangeMdp = (e) => {
            const field = e.target.name
            const value = e.target.value
            this.setState({
                [field]: value
            })
        }
        deleteReappro = async () => {

            try{
                await this.props.deleteReappro(this.state.toDelete)
                toast.success( "Reappro supprimée avec succès")
                this.setState({
                    deletePopUp:false,
                    toDelete:{id: ""},
                })
            }catch(err){
                console.log("[ERROR] delete reappro", err.message); 
                toast.error(  "Un Problème est survenu"+err.message)
        
            }
        }
        
        handleSelectMulti = (option, name) => {
            if(option){
                this.setState({                
                    [name]: option,
                    currentPage: 0,
                    currentPageProd: 0,
                })
            } else {
                this.setState({
                    [name]: {label: "", value: ""},
                    currentPage: 0,
                    currentPageProd: 0,
                })
    
            }
        }
        
    // CLEAR & DISPLAY        
        handleClose = () => {
            this.setState({
                showSale:false,
                showNew:false,
                showSingleProd: false,
                showSingleShop: false,
                breadcrumb: "",
                currentPage: 0,
                end_date: new Date(),
            });
        }

        handleSingleShop = (shop) => {
            this.setState({
                breadcrumb: shop.name,
                singleShop:shop,
                showSingleShop: true
            })

        }
        handleSingleSale = (reappro, shop, shopDest) => {
            this.setState({
                showSale:true,
                singleSale:{sale:reappro, shop, shopDest},
                breadcrumb:`Reappro n°${reappro.id}`
            })

        }
        handleDelete = (reappro) => {
            this.setState({
                toDelete: reappro,
                deletePopUp : true,
            })
        }


    render(){
        console.log("[STATE] ",this.state);
        
        // let shops = this.createShopList()
        
        return(
            <CardPage 
                title="Reapprovisionnement"
                storehouse
                action={!this.state.showSale && !this.state.showSingleShop && !this.state.showSingleProd && !this.state.showNew &&
                    <Box>
                        <Button 
                            color="primary" 
                            variant="contained"
                            onClick={ () => this.setState({showNew: true, breadcrumb:"Nouveau"}) }
                        > Nouveau
                        </Button>
                    </Box>
                }
            >
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Reapprovisionnements" back={this.handleClose} />
                {this.state.deletePopUp && this.state.toDelete.id &&
                    <DeleteDialog
                        title={"le reapprovisionnement n°"+this.state.toDelete.id}
                        handleSubmit={this.deleteReappro}
                        close={()=>this.setState({deletePopUp: false})}
                        open={true}
                        disabled={this.props.STATE.sales.fetching}
                    />
                }
                
                {this.state.showSingleShop &&                        
                    <SingleShop shop={this.state.singleShop} {...this.props} />
                }       
                
                {this.state.showNew &&
                    <FormReappro
                        {...this.props}
                        handleClose={this.handleClose}
                        // filterList={this.filterList}
                    />
                }
                {this.state.showSale && !this.state.showNew &&
                    <SingleTransferReappro
                        transfer={this.state.singleSale.sale} 
                        shop={this.state.singleSale.shop} 
                        shopDest={this.state.singleSale.shopDest} 
                        {...this.props} 
                        getPhoto={this.props.getPhoto}
                    />
                }
                {!this.state.showSale && !this.state.showSingleShop && !this.state.showSingleProd && !this.state.showNew &&
                <Box>
                    <AccordionFilter>
                        <Grid container >
                            <DateFilter
                                handleChangeDate={(date, name) => this.setState({ [name]: date })}
                                {...this.state}
                            />
                            <Grid item xs={12} sm={6}>
                                <ShopFilter
                                    label="Magasin Source"
                                    fieldName="selectShopSRC"
                                    value={this.state.selectShopSRC}
                                    handleSelect={this.handleSelectMulti}
                                    />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <ShopFilter
                                    label="Magasin Destinataire"
                                    fieldName="selectShopDEST"
                                    value={this.state.selectShopDEST}
                                    handleSelect={this.handleSelectMulti}
                                    id="select_dest"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputSelect
                                    options={[
                                        {value: "ALL", label: "Tous"},
                                        {value: true, label: "Reçu"},
                                        {value: false, label: "En attente"},
                                    ]}
                                    value={this.state.received}
                                    label="Etat"
                                    onChange={(option) => this.setState({ received: option.value }) }
                                        // this.filterList(undefined, option.value)
                                /> 
                            </Grid>
                        </Grid>
                    </AccordionFilter>
                    {this.props.STATE.sales.fetching && <Spin noOverlay/>}

                    {/* {!isEmpty(this.props.PURCHASES_REAPPRO) && !isEmpty(this.props.REAPPRO) && */}
                        <ListTransferReappro 
                            {...this.state}
                            {...this.props}
                            handleSingleShop={this.handleSingleShop}
                            handleSingleSale={this.handleSingleSale}
                            changeStatus={this.changeStatus}
                            handleDelete={this.handleDelete}
                            onChangePage={this.onChangePage}
                            // filteredList={this.state.filteredList}
                            getFilteredList={this.getFilteredList}
                        />  
                    {/* } */}

                    {/* <div className="text-center">
                        {this.state.reload &&
                            <Pagination items={this.state.filteredList} onChangePage={this.onChangePage} pageSize={15} initialPage={this.state.currentPage || 1}/>
                        }
                        {!this.state.reload &&
                            <Pagination items={this.state.filteredList} onChangePage={this.onChangePage} pageSize={15} initialPage={this.state.currentPage || 1}/>
                        }
                    </div> */}
                </Box>
                }
                
            </CardPage>

        )
    }
}



export default ReapproIntern